import { createSlice } from '@reduxjs/toolkit';
const initialState = {
  title: '',
  description: ''
};
const MAX_LENGTH = 2048;
const entryUrlMetadataSlice = createSlice({
  name: 'entryUrlMetadata',
  initialState,
  reducers: {
    setEntryUrlMetadata(state, action) {
      if (action.payload.title !== state.title) {
        state.title = action.payload.title.substring(0, MAX_LENGTH);
      }
      if (
      /**
       * @description Cached embed JS can return action.payload.description as undefined
       * @deprecated This is a temporary check to ensure that the description is a string.
       * @temporary Remove typeof check once embed has rolled out for some time
       * @expiration 2025-10-29
       */
      typeof action.payload.description === 'string' && action.payload.description !== state.description) {
        state.description = action.payload.description.substring(0, MAX_LENGTH);
      }
    }
  }
});
export const {
  setEntryUrlMetadata
} = entryUrlMetadataSlice.actions;
export default entryUrlMetadataSlice.reducer;